import {AxiosResponse} from "axios";
import Api from "./api";

interface ILogin {
    email: string;
    password: string;
}


interface IRegistration {
    email: string;
    password: string;
    lastname: string;
    firstname: string;
    middlename: string;
}


export default class AuthService {
    static async Login(payload: any): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/auth/login', payload);
    }

    static async registration(fields: IRegistration): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/auth/registration', fields);
    }

    static async check(): Promise<AxiosResponse<any>> {
        return await Api.get<any>('/auth/check');
    }

    static async Logout(): Promise<AxiosResponse<any>> {
        return await Api.post<any>('/auth/logout');
    }
}